import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { unitSellBysQuerySchema } from './unit-sell-bys-query-schema';

export const unitSellBysFormSchema = unitSellBysQuerySchema
  .omit({ name: true, status: true, plural: true, products_count: true })
  .extend({
    name: z.string().min(3),
    plural: z.string(),
    status: statusFormSchema,
  });
export type UnitSellBysFormSchema = z.infer<typeof unitSellBysFormSchema>;
